<template>
  <div v-loading="loading" class="backend-form">
    <div class="row">
      <div class="col-sm-3">
        <el-form>
          <el-form-item>
            <label slot="label" for="search">Nro de ticket o socio</label>
            <el-input id="search" v-model="search" type="search"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-button-group>
      <el-button
        :type="airline === null ? 'primary' : ''"
        @click="airline = null"
        >General</el-button
      >
      <el-button
        :type="airline === 'AA' ? 'primary' : ''"
        @click="airline = 'AA'"
        >Vuelos American Airlines</el-button
      >
      <el-button
        :type="airline === 'DL' ? 'primary' : ''"
        @click="airline = 'DL'"
        >Vuelos Delta Air Lines</el-button
      >
    </el-button-group>

    <div class="text-right">
      <button
        type="button"
        class="btn btn-danger btn-sm"
        :disabled="multipleSelection.length === 0 || processing"
        @click="retro(null, false)"
      >
        Rechazar
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        :disabled="multipleSelection.length === 0 || processing"
        @click="retro(null, true)"
      >
        Aprobar
      </button>
    </div>
    <br />

    <el-table
      v-if="data"
      ref="table"
      :data="data"
      :height="600"
      style="width: 100%"
      stripe
      row-key="id"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div v-if="scope.row.processing">Procesando...</div>
          <div v-else-if="scope.row.response">
            {{ scope.row.response.error.message }}
          </div>
          <div v-else>No se ha ejecutado el retro</div>
        </template>
      </el-table-column>
      <el-table-column type="selection" fixed></el-table-column>
      <el-table-column
        label="Fecha Solicitud"
        prop="created_at"
        sortable="custom"
      >
        <template slot-scope="scope">{{
          moment(scope.row.created_at).format("DD MMM YYYY")
        }}</template>
      </el-table-column>
      <el-table-column
        label="FFN"
        prop="latam_id"
        sortable="custom"
        :width="100"
      >
        <template slot-scope="scope">{{ scope.row.retro.latam_id }}</template>
      </el-table-column>
      <el-table-column
        label="Fecha Registro Socio"
        prop="latam_enrollment_date"
        sortable="custom"
      >
        <template slot-scope="scope">{{
          moment(scope.row.retro.user.latam_enrollment_date).format(
            "DD MMM YYYY"
          )
        }}</template>
      </el-table-column>
      <el-table-column label="Nº de Ticket">
        <template slot-scope="scope">{{
          formatTicketNumber(scope.row.retro.ticket_number)
        }}</template>
      </el-table-column>
      <el-table-column label="Aerolínea" prop="airline" sortable="custom">
        <template slot-scope="scope">{{ scope.row.airline }}</template>
      </el-table-column>
      <el-table-column label="Origen / Destino" prop="origin" sortable="custom">
        <template slot-scope="scope"
          >{{ scope.row.origin }} {{ scope.row.destination }}</template
        >
      </el-table-column>
      <el-table-column
        label="Fecha de viaje"
        prop="flight_date"
        sortable="custom"
      >
        <template slot-scope="scope">{{
          formatFlightDate(scope.row.flight_date)
        }}</template>
      </el-table-column>
      <el-table-column label="Nombre Pasajero" :width="100">
        <template slot-scope="scope">{{
          scope.row.retro.passenger_name
        }}</template>
      </el-table-column>
      <el-table-column label="Nombre Socio" :width="100">
        <template slot-scope="scope">{{ scope.row.retro.user.name }}</template>
      </el-table-column>
      <el-table-column
        label="Match Nombres (%)"
        align="right"
        sortable="custom"
        prop="fuzzywuzzy"
      >
        <template slot-scope="scope">{{
          numeral(scope.row.fuzzywuzzy).format("0%")
        }}</template>
      </el-table-column>
      <el-table-column label="Tier" prop="latam_tier" sortable="custom">
        <template slot-scope="scope">{{
          scope.row.retro.user.latam_tier
        }}</template>
      </el-table-column>
      <el-table-column label="Validación de usuario">
        <template slot-scope="scope">
          <div
            v-if="scope.row.retro.user.validated === null"
            class="validation-cell"
          >
            <div v-if="scope.row.retro.user.lowtier">
              <a href="#" @click.prevent="validateDialog(scope.row.retro.user)">
                <div
                  class="image"
                  :style="{
                    'background-image':
                      'url(api/v1/backend/users/' +
                      scope.row.retro.user.id +
                      '/validation_image)'
                  }"
                ></div>
              </a>
              <div>
                <a
                  href="#"
                  @click.prevent="validateDialog(scope.row.retro.user)"
                  >Validar</a
                >
              </div>
            </div>
            <div v-else>N/A</div>
          </div>
          <div v-else-if="scope.row.retro.user.validated === 1">
            Validada
            <br />(
            <a href="#" @click.prevent="validateDialog(scope.row.retro.user)"
              >Revalidar</a
            >)
          </div>
          <div v-else-if="scope.row.retro.user.validated === 0">
            Invalidada
            <br />(
            <a href="#" @click.prevent="validateDialog(scope.row.retro.user)"
              >Revalidar</a
            >)
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="['AA'].indexOf(airline) >= 0"
        label="Comprobante de compra"
      >
        <template slot-scope="scope">
          <div v-if="['AA'].indexOf(airline) >= 0">
            <a
              href="#"
              @click.prevent="
                displayImageDialog(
                  'api/v1/backend/segments/' +
                    scope.row.id +
                    '/proof_of_purchase'
                )
              "
              ><div
                class="image"
                :style="{
                  'background-image':
                    'url(api/v1/backend/segments/' +
                    scope.row.id +
                    '/proof_of_purchase)'
                }"
              ></div
            ></a>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="['AA', 'DL'].indexOf(airline) >= 0"
        label="Boarding Pass"
      >
        <template slot-scope="scope">
          <div v-if="['AA', 'DL'].indexOf(airline) >= 0">
            <a
              href="#"
              @click.prevent="
                displayImageDialog(
                  'api/v1/backend/segments/' + scope.row.id + '/boarding_pass'
                )
              "
              ><div
                class="image"
                :style="{
                  'background-image':
                    'url(api/v1/backend/segments/' +
                    scope.row.id +
                    '/boarding_pass)'
                }"
              ></div
            ></a>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="['AA', 'DL'].indexOf(airline) >= 0"
        label="Documento de Identificación"
      >
        <template slot-scope="scope">
          <div v-if="['AA', 'DL'].indexOf(airline) >= 0">
            <a
              href="#"
              @click.prevent="
                displayImageDialog(
                  'api/v1/backend/segments/' + scope.row.id + '/id_document'
                )
              "
              ><div
                class="image"
                :style="{
                  'background-image':
                    'url(api/v1/backend/segments/' +
                    scope.row.id +
                    '/id_document)'
                }"
              ></div
            ></a>
          </div>
        </template>
      </el-table-column>
      <el-table-column :width="160" fixed="right" label="Acciones">
        <template slot-scope="scope">
          <div style="white-space: nowrap">
            <button
              :disabled="rowIsDisabled(scope.row)"
              type="button"
              class="btn btn-danger btn-sm"
              @click="retro(scope.row, false)"
            >
              Rechazar
            </button>
            <button
              :disabled="
                rowIsDisabled(scope.row) || approveIsDisabled(scope.row)
              "
              type="button"
              class="btn btn-primary btn-sm"
              @click="retro(scope.row, true)"
            >
              Aprobar
            </button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="text-right">
      Mostrando {{ Math.min(pageSize, total) }} de {{ total }} registros.
    </div>

    <div class="text-center">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
      ></el-pagination>
    </div>

    <el-dialog
      v-if="imageDialog"
      title="Visualizador"
      :visible.sync="imageDialogVisible"
    >
      <div style="position: relative; text-align: center;">
        <a
          href="#"
          style="position: absolute; top: 0; left: 0; z-index: 100"
          @click.prevent="imageDialogRotation = imageDialogRotation + 90"
          >Rotar</a
        >

        <div
          style="display: inline-block; width: 496px; height: 318px; background-size: contain; background-repeat: no-repeat;"
          :style="{
            'background-image': 'url(' + imageDialog.url + ')',
            transform: 'rotate(' + imageDialogRotation + 'deg)'
          }"
        ></div>
      </div>
    </el-dialog>

    <el-dialog
      v-if="validation"
      title="Verificación de Identidad"
      :visible.sync="dialogVisible"
    >
      <div style="position: relative; text-align: center;">
        <a
          href="#"
          style="position: absolute; top: 0; left: 0; z-index: 100"
          @click.prevent="rotation = rotation + 90"
          >Rotar</a
        >
        <div
          style="display: inline-block; width: 496px; height: 318px; background-size: contain; background-repeat: no-repeat;"
          :style="{
            'background-image':
              'url(api/v1/backend/users/' +
              validation.user.id +
              '/validation_image)',
            transform: 'rotate(' + rotation + 'deg)'
          }"
        ></div>
      </div>
      <br />
      <table style="width: 100%;">
        <tr>
          <td>
            <h4>Nº de Socio</h4>
            <div>{{ validation.user.latam_id }}</div>
          </td>
          <td>
            <h4>Nombre</h4>
            <div>{{ validation.user.first_name }}</div>
          </td>
          <td>
            <h4>Apellido</h4>
            <div>{{ validation.user.last_name }}</div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td>
            <h4>Fecha de Registro FFP</h4>
            <div>
              {{
                moment(validation.user.latam_enrollment_date).format(
                  "DD MMM YYYY"
                )
              }}
            </div>
          </td>
        </tr>
      </table>

      <span slot="footer" class="dialog-footer">
        <button
          class="btn btn-danger"
          type="button"
          @click="validate(validation.user, false)"
        >
          Rechazar
        </button>
        <button
          class="btn btn-success"
          type="button"
          @click="validate(validation.user, true)"
        >
          Validar
        </button>
      </span>
    </el-dialog>
  </div>
</template>
<style lang="scss">
.backend-form {
  .el-form {
    .el-form-item {
      .el-form-item__label {
        line-height: 1;
        font-weight: bold;
        margin: 0;
      }
    }
  }
  .el-table {
    thead {
      tr {
        th {
          padding: 0;
          .cell {
            white-space: normal;
            word-break: normal;
            font-size: 12px;
            padding: 5px 20px 5px 5px;
            line-height: 1;
            .caret-wrapper {
              position: absolute;
              top: 0;
              right: 0;
            }
          }
        }
      }
    }
    tbody {
      tr {
        td {
          padding: 0;
          .cell {
            white-space: normal;
            word-break: normal;
            font-size: 12px;
            padding: 5px;
            line-height: 1;
            .validation-cell {
              white-space: nowrap;
            }
            .image {
              display: inline-block;
              width: 70px;
              height: 55px;
              background-size: contain;
              background-repeat: no-repeat;
            }
          }
          .el-table__expanded-cell {
            padding: 10px;
          }
        }
      }
    }
  }
}
</style>

<script>
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import async from "async";
import numeral from "numeral";
import formatTicketNumber from "../Methods/FormatTicketNumber";

export default {
  data() {
    return {
      loading: false,
      data: null,
      dialogVisible: false,
      rotation: 0,
      validation: null,
      multipleSelection: [],
      processing: false,
      pageSize: 50,
      currentPage: 1,
      total: 0,
      sortProp: null,
      sortOrder: null,
      search: "",
      airline: null,
      imageDialogVisible: false,
      imageDialog: null,
      imageDialogRotation: 0
    };
  },
  computed: {
    /*
    total() {
      if (!this.data) return 0;

      return this.data.length;
    },

    pageData() {
      if (!this.data) return null;

      const offset = (this.currentPage - 1) * this.pageSize;
      return this.data.slice(offset, offset + this.pageSize);
    }
    */
    pageProps() {
      return (
        this.currentPage +
        this.sortProp +
        this.sortOrder +
        this.search +
        this.airline
      );
    }
  },
  watch: {
    pageProps() {
      this.refreshData();
    }
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    numeral,
    moment,
    get: _.get,
    formatTicketNumber,
    // Vue binds methods, so the template's `moment` loses static helpers like `utc`
    formatFlightDate(date) {
      return moment.utc(date).format("DD MMM YYYY");
    },
    refreshData() {
      this.loading = true;
      axios
        .get("api/v1/backend/retros", {
          params: {
            limit: this.pageSize,
            page: this.currentPage,
            order: this.sortProp,
            direction: this.sortOrder === "ascending" ? "asc" : "desc",
            search: this.search.replace("-", ""),
            airline: this.airline
          }
        })
        .then(response => {
          this.data = response.data.data.map(d =>
            _.merge(d, { processing: false, response: null })
          );
          this.total = response.data.total;
          this.loading = false;
        });
    },
    validateDialog(user) {
      this.dialogVisible = true;
      this.validation = {
        user
      };
    },
    displayImageDialog(url) {
      this.imageDialogVisible = true;
      this.imageDialog = {
        url
      };
    },
    validate(user, validated) {
      axios
        .put(`api/v1/backend/users/${user.id}`, { validated })
        .then(() => {
          this.refreshData();
          this.dialogVisible = false;
        })
        .catch(() => {});
    },
    async retro(row, approved) {
      let rows;
      if (row) {
        rows = [row];
      } else {
        rows = this.multipleSelection;
      }

      this.processing = true;
      async.each(
        rows,
        (myRow, cb) => {
          const r = myRow;
          r.processing = true;
          this.$refs.table.toggleRowExpansion(r, true);
          axios
            .put(`api/v1/backend/retros/${r.id}`, { approved })
            .then(response => {
              r.processing = false;
              this.refreshData();
              cb(null, response);
            })
            .catch(err => {
              r.response = err.response.data;

              r.processing = false;
              cb(err);
            });
        },
        () => {
          this.processing = false;
        }
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange({ order, prop }) {
      this.sortProp = prop;
      this.sortOrder = order;
    },
    rowIsDisabled(row) {
      if (row.processing) return true;

      if (row.retro.user.validated === null && row.retro.user.lowtier)
        return true;

      return false;
    },
    approveIsDisabled(row) {
      if (row.retro.user.lowtier && !row.retro.user.validated) return true;

      return false;
    }
  }
};
</script>
